export const applyRecursive = <T>(
	fnsOuter: Array<(fnInner: () => T) => T>,
	fnInner: () => T
): T => {
	if (fnsOuter.length === 0) {
		return fnInner();
	}
	const [fnOuter, ...nextFnsOuter] = fnsOuter;
	return fnOuter(() => applyRecursive(nextFnsOuter, fnInner));
};
